import { Tabs } from '@neo4j-ndl/react';
import { Page, PageTitle } from '@nx/ui';
import React, { useState } from 'react';

import { ApiKeysCard } from './api-keys';
import { PreferencesCard } from './preferences';
import { ProfileCard } from './profile';

export const AccountPage = () => {
  const [tabId, setTabId] = useState<number>(0);

  return (
    <Page contentType="light">
      <PageTitle
        title="Account settings"
        back={{
          label: 'Back to overview',
          toUrl: '../projects',
        }}
      />

      <Tabs fill="underline" onChange={(newTabId: number): void => setTabId(newTabId)} value={tabId} size="small">
        <Tabs.Tab tabId={0}>General</Tabs.Tab>
        <Tabs.Tab tabId={1}>API keys</Tabs.Tab>
      </Tabs>

      <Tabs.TabPanel tabId={0} value={tabId} className="flex flex-auto flex-col gap-8">
        <ProfileCard />
        <PreferencesCard />
      </Tabs.TabPanel>
      <Tabs.TabPanel tabId={1} value={tabId} className="flex flex-auto flex-col">
        <ApiKeysCard />
      </Tabs.TabPanel>
    </Page>
  );
};
